"use strict";

exports.__esModule = true;
exports.SUPPORTED_LOCALES = exports.SUPPORTED_LANGUAGES = exports.STORAGE_LOCALE_KEY = exports.REALTIME_URL = void 0;
var STORAGE_LOCALE_KEY = exports.STORAGE_LOCALE_KEY = "vi-locale-key";
var SUPPORTED_LOCALES = exports.SUPPORTED_LOCALES = {
  "pt-BR": {
    longName: "Brazilian Portuguese",
    locale: "",
    language: "pt",
    country: "PT"
  },
  "zh-cn": {
    longName: "Chinese",
    locale: "",
    language: "zh",
    country: "CN"
  },
  "en-us": {
    longName: "English",
    locale: "",
    language: "en",
    country: "US"
  },
  "fr-fr": {
    longName: "French",
    locale: "",
    language: "fr",
    country: "FR"
  },
  "de-de": {
    longName: "German",
    locale: "",
    language: "de",
    country: "DE"
  },
  "it-it": {
    longName: "Italian",
    locale: "",
    language: "it",
    country: "IT"
  },
  "ja-jp": {
    longName: "Japanese",
    locale: "",
    language: "ja",
    country: "JA"
  },
  "ko-kr": {
    longName: "Korean",
    locale: "",
    language: "ko",
    country: "KO"
  },
  "pl-pl": {
    longName: "Polish",
    locale: "",
    language: "pl",
    country: "PL"
  },
  "hu-hu": {
    longName: "Hungarian",
    locale: "",
    language: "hu",
    country: "HU"
  },
  "es-es": {
    longName: "Spanish",
    locale: "",
    language: "es",
    country: "ES"
  },
  "fi-FI": {
    longName: "Finnish",
    locale: "",
    language: "fi",
    country: "FI"
  }
};

/**
 * example { "it": { locale:"it-it" ...seeAbove } }
 */
var byLanguage = Object.keys(SUPPORTED_LOCALES).reduce(function (languages, locale) {
  var details = SUPPORTED_LOCALES[locale];
  languages[details.language] = details;
  return languages;
}, {});
var SUPPORTED_LANGUAGES = exports.SUPPORTED_LANGUAGES = byLanguage;
var REALTIME_URL = exports.REALTIME_URL = "wss://api.staging.vimana.us/api/v3/realtime/";